import Cookies from 'js-cookie'

// Be aware of CookieHelper:: -> configuration must be the same, or cookies will be unreadable from .js

const DEFAULT_OPTIONS = { sameSite: 'lax' }

const APP_DEFAULT_EXPIRATION = 365
const MODAL_DEFAULT_EXPIRATION = 1 / 24
const HOMEPAGE_DEFAULT_EXPIRATION = 7

const APP_LANGUAGE = 'app_language'
const HOMEPAGE_AMOUNT = 'homepage_form_amount'
const HOMEPAGE_INSTALLMENTS = 'homepage_form_installments'
const HOMEPAGE_PRODUCT_TYPE = 'homepage_form_product_type'
const HOMEPAGE_PROMO_CODE = 'homepage_form_promo_code'

// -------------- Get/Set --------------

export const getCookie = (key) => Cookies.get(key)

export const setCookie = (key, value, options = {}) => Cookies.set(key, value, { ...DEFAULT_OPTIONS, ...options })

// -------------- App --------------

export const getAppLanguageCookie = () => getCookie(APP_LANGUAGE)

export const setAppLanguageCookie = (value) => setCookie(APP_LANGUAGE, value, { expires: APP_DEFAULT_EXPIRATION })

// -------------- Modals --------------

export const setModalTimeoutCookie = (key, value) => setCookie(key, value, { expires: MODAL_DEFAULT_EXPIRATION })

// -------------- Homepage --------------

export const getHomepageCookies = () => [Cookies.get(HOMEPAGE_AMOUNT), Cookies.get(HOMEPAGE_INSTALLMENTS), Cookies.get(HOMEPAGE_PRODUCT_TYPE), Cookies.get(HOMEPAGE_PROMO_CODE)]

export const setAmountCookies = (amount) => setCookie(HOMEPAGE_AMOUNT, amount, { expires: HOMEPAGE_DEFAULT_EXPIRATION })

export const getInstallmentsCookies = () => getCookie(HOMEPAGE_INSTALLMENTS)

export const setInstallmentsCookies = (installments) => setCookie(HOMEPAGE_INSTALLMENTS, installments, { expires: HOMEPAGE_DEFAULT_EXPIRATION })
